import React, { useCallback, useEffect,useMemo,useRef,useState } from "react";
import clxs from "./locations.module.css";
import LocationHeader from "./LocationHeader";
//import LocationExperience from "./LocationExperience";
import VillaItem from "../VillaItem";
import usePathParams from "../../hooks/use-path-params";
import decodeLocationSlug from "../../../utils/decode-location-slug";
import { Track } from "../AnalyticsManager";
import {useQueryParam, useQueryParamValue } from "../../hooks/use-query-param";
import usePropertyListing from "../../hooks/use-property-listing";
import { useScroll } from "../../hooks/use-scroll";
import Modal, { useShowModal } from "../../hooks/use-modal";
import Gallery from "../PropertyDetail/Gallery";
import LandingpageForm from "../LandingPageForm";
import LocationFooter from "./LocationFooter";
import LocationLoader from "./LocationLoader";
import LocationContactUsFooter from "./LocationLoader/LocationContactUsFooter";
//import NoVillasFound from "../CollectionListing/NoVillasFound";
import { LOCATIONS_BANNER_MAP } from "./location-banner-template";
import NotFound from "../NotFound";
import OffersAndDiscounts from "../OffersAndDiscounts";
import useOffersListing from "../../hooks/use-offers-listing";
import SortDesktop from "../PropertyListing/Sort/Desktop";
import useAnalytics from "../../hooks/use-analytics";
import usePropertyLocations from "../../hooks/use-property-locations";
import DetailForm from "../VillaItem/DetailForm";
import Header from "../Checkout/Header";

function Locations() {
  const 
    { track } = useAnalytics(),
    { propertyLocations } = usePropertyLocations(),
    showDetailForm = useShowModal(DETAIL_FORM_MODAL_ID),
    location_slug = usePathParams(PATH, "location_slug") || "india-goa",
    destination= useQueryParamValue("string", "destination") || "default",
    location = usePathParams(PATH, "location"),
    checkin_date = useQueryParamValue("date", "checkin_date"),
    checkout_date = useQueryParamValue("date", "checkout_date"),
    adult_count = useQueryParamValue("integer", "adult_count"),
    child_count = useQueryParamValue("integer", "child_count"),
    [sort, setSort] = useQueryParam("string", "sort"),
    search = useQueryParamValue("string", "search"),
    formRef = useRef<HTMLDivElement>(null),
    isDefautBannerExists = LOCATIONS_BANNER_MAP[`${destination}`],
    banner = LOCATIONS_BANNER_MAP[`${destination}`] ? LOCATIONS_BANNER_MAP[`${destination}`]?.image : LOCATIONS_BANNER_MAP["default"].image,
    title = LOCATIONS_BANNER_MAP[`${destination}`]?.title || LOCATIONS_BANNER_MAP["default"].title,
    subtitle =  LOCATIONS_BANNER_MAP[`${destination}`]?.subtitle || LOCATIONS_BANNER_MAP["default"].subtitle,
    footerSubtitle = LOCATIONS_BANNER_MAP[`${destination}`]?.footerSubtitle || LOCATIONS_BANNER_MAP["default"].footerSubtitle,
    { properties, getNextPage, isLoading, propertyCount } = usePropertyListing(
      location_slug,
      undefined,
      checkin_date?.toISOString(),
      checkout_date?.toISOString(),
      adult_count,
      child_count,
      search,
      sort,
    ),
    { ratio } = useScroll(),
    [lengthId, setLengthId] = useState<number>(0),
    { offers } = useOffersListing(location_slug),
    showInternational = useMemo(
      () => {
        return LOCATIONS_BANNER_MAP[`${destination}`]?.annotation === "domestic";
      },
      [destination],
    ),
     // Find location name
     destinationFriendly = useMemo(
      () => {
        const friendly = propertyLocations
          .find(each => each.slug === location_slug)?.name || "";

        return friendly;
      },
      [propertyLocations, location_slug],
    ),
     // Subtitle based on the location
     headerSubtitle = useMemo(() => {
      //handled exception for north-goa location
      if (location === "north-goa") {
        return "Luxury villas in North Goa"
      } else {
        return `Luxury villas in ${destinationFriendly}`
      }
    }, [destinationFriendly, propertyCount]),
    handleRatioChange = (ratio: number) => {
      if (ratio < 0.6) {
        return;
      }

      if (lengthId === properties.length) {
        return;
      }

      setLengthId(properties.length);
    },
    handleSortChange = (nextDirection: string) => {
      track(
        "property_listing_sort_clicked",
        { sort: nextDirection },
      );

      return setSort(nextDirection);
    },
    handleShowDetailForm= useCallback(
      ( property: PropertyItem) => {
        showDetailForm({property})
      },
      [],
    );

  useEffect(() => handleRatioChange(ratio), [ratio]);

  useEffect(() => {
    if (!lengthId) {
      return;
    }

    getNextPage();
  }, [lengthId]);

  if (!isDefautBannerExists) {
    return <NotFound/>;
  }

  return (
 <>
  <Header isLocationPageHeader={true}/>
  <div>
    <div className={clxs.container}>

      <LocationHeader
        banner={banner}
        className={clxs.bannerSection}
        bannerTitle={title}
        subtitle={subtitle}
      />
      {/* <LocationExperience className={clxs.experienceSection} /> */}

      <div className={clxs.properties}>
       
        {isLoading ? 
          <LocationLoader isLoading={isLoading}></LocationLoader>  
         : 
          <>
           <div className={clxs.titleContainer}>
          {propertyCount == 0 ?
            <p>
              No villas found.
            </p>
            :
            <div className={clxs.headerTitle}>
              <div className={clxs.headerSubtitle}>{headerSubtitle}</div>
              <div className={clxs.propertyCount}> {propertyCount} {propertyCount > 1 ? "Properties" : "Property"} found</div>
            </div>
          }
          <SortDesktop
            className={clxs.sortDesktop}
            value={sort}
            onChange={handleSortChange}
          />
        </div>
          {properties.map((each, i) => {
            const decodedLocation = decodeLocationSlug(each.location_slug),
              { location, destination } = decodedLocation,
              propertySlug = each.property_slug,
              href = `/villas/${destination}/${location}/${propertySlug}`,
              payload: any = {
                ...each,
                ...decodedLocation,
                href: href,
                index: i,
              };

            return (
              <Track 
                key={i} 
                event="villa_property_clicked" 
                payload={payload}
              >
                <VillaItem 
                  className={clxs.villaItem} 
                  property={each} 
                  handleShowDetailForm={()=>handleShowDetailForm(each)}
                />
              </Track>
            );
          })}
          </>
        } 
      </div>

      <div className={clxs.sendRequestContainer}>
          <OffersAndDiscounts
            className={clxs.offersAndDiscounts}
            offersData={offers}
          />
          <LandingpageForm
            className={`${clxs.sendRequest} ${clxs.hideSendRequestMobile}`}
            title="Immediate Assistance" 
            formId="landing_page_form_top"
            showInternational={showInternational}
            ref={formRef}
          />
      </div>

      <div className={clxs.sendRequestContainer2}>
          <LandingpageForm
            className={clxs.sendRequest}
            title="Immediate Assistance" 
            formId="landing_page_form_bottom"
            showInternational={showInternational}
          />
      </div>
      <Modal id={GALLERY_MODAL_ID}>
          <Gallery isLocationPageImage={true}/>
      </Modal>
    </div>
     <LocationFooter
       className={clxs.locationFooter}
       footerSubtitle={footerSubtitle}
     />
     <LocationContactUsFooter/>
  </div>
   <Modal id={DETAIL_FORM_MODAL_ID}>
    <DetailForm/>
   </Modal>
 </>
  );
}

export default Locations;

const GALLERY_MODAL_ID = "villa-gallery-mobile";

const DETAIL_FORM_MODAL_ID = "detail-form";

const PATH = "/locations/:location_slug";


